/**
 * Resultsgate API
 * Open API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum OrderStatus {
    COMPLETED = 'COMPLETED',
    NEW = 'NEW',
    PAID = 'PAID',
    PROCESSING = 'PROCESSING',
    RESULTSREADY = 'RESULTS_READY',
    STORNO = 'STORNO',
    WAITINGFORKIT = 'WAITING_FOR_KIT',
    WAITINGFORPAYMENT = 'WAITING_FOR_PAYMENT',
    WAITINGFORSAMPLES = 'WAITING_FOR_SAMPLES'
};

